export default __webpack_public_path__ + "static/media/inner-page-header-01.b070f387.png";